import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "toggleIcon", "badge"]

  toggle() {
    this.panelTarget.classList.toggle("hidden")

    if (this.hasToggleIconTarget) {
      const isOpen = !this.panelTarget.classList.contains("hidden")
      this.toggleIconTarget.classList.toggle("fa-chevron-down", !isOpen)
      this.toggleIconTarget.classList.toggle("fa-chevron-up", isOpen)
    }
  }

  clearFilters() {
    const form = this.element.querySelector("form")
    if (!form) return

    // Keep the search query (q) but clear all filter fields
    form.querySelectorAll("input[type='date'], select").forEach(el => {
      el.value = ""
    })

    form.submit()
  }
}
